import booklet from '../../assets/files/ru/Справочник_вкладчика.pdf';
import certificate from '../../assets/files/ru/Вх._корр._от_Государственная_корпорация_Агентство_по_страхованию_вкладов_№2024-00291_от_29._(13662v2).pdf';
import centralBankLicense from '../../assets/files/ru/Лицензия_Банка_России_№3538_от_12 апреля.pdf';
import Base_QR from '../../assets/files/ru/QR-Лицензия_ЦБ_РФ_№3538_от_12_апреля_2019.pdf';
import pciDSSCertified from '../../assets/files/ru/Certificate_PCI_DSS_LLC_2026.pdf';
import listInsiderInfo_2026 from '../../assets/files/ru/listInsiderInfo_2026.pdf';
import listInsiderInfo_2022 from '../../assets/files/ru/listInsiderInfo_2022.pdf';
import pdProtection from '../../assets/files/ru/personal_data_processing_policy.pdf';
import audit_2019 from '../../assets/files/ru/Audit_2019.pdf';
import suot_2020 from '../../assets/files/ru/SUOT_2020.pdf';
import W_8BEN_E from '../../assets/files/ru/W-8BEN-E.pdf';
import W_8IMY from '../../assets/files/ru/W-8IMY.pdf';
import glossary from '../../assets/files/ru/Glossary.pdf';
import poyasnitelnaya_inf_k_otchetnosti_9_mes_2020 from '../../assets/files/ru/Poyasnitelnaya_inf_k_otchetnosti_9_mes_2020.pdf';
import otchetnost_9_mes_2020 from '../../assets/files/ru/Otchetnost_9_mes_2020.pdf';
import otchetnost_1_polugodie_2020 from '../../assets/files/ru/Otchetnost_1_polugodie_2020.pdf';
import poyasnitelnaya_inf_k_otchetnosti_1_polugodie_2020 from '../../assets/files/ru/Poyasnitelnaya_inf_k_otchetnosti_1_polugodie_2020.pdf';
import {
  BANK_ADDRESS,
  BANK_BIK,
  BANK_CORR_ACC,
  BANK_INN_KPP,
  BANK_OGRN,
  BANK_PHONE
} from '../../constants';
import { formatPhoneNumber } from '../../utils/formatPhoneNumber';

export default {
  seo: {
    title: 'Реквизиты | Банк 131',
    description: 'Реквизиты АО «Банк 131»',
  },
  // Необходимо для рендеринга контента
  variantContent: {
    requisite: 'requisite',
    offices: 'offices',
    bankManagement: 'bankManagement',
    centralBankLicense: 'centralBankLicense',
    pciDSSCertified: 'pciDSSCertified',
    pdProtection: 'pdProtection',
    fatcaCompliance: 'fatcaCompliance',
    crsCompliance: 'crsCompliance',
    listInsiderInfo: 'listInsiderInfo',
    2026: '2026',
    2025: '2025',
    2024: '2024',
    2023: '2023',
    2022: '2022',
    2021: '2021',
    2020: '2020',
    2019: '2019',
    depositInsurance: 'depositInsurance',
    osms2020Report: 'osms2020Report',
    bpa: 'bpa',
    ombudsman: 'ombudsman',
    importantUpdates: 'importantUpdates',
    infoRates: 'infoRates',
    codeOfCorporateEthics: 'codeOfCorporateEthics',
    regulationsOnCombatingCommercialBriberyAndCorruption: 'regulationsOnCombatingCommercialBriberyAndCorruption'
  },

  content: {
    requisite: {
      rectangle: [
        {
          title: 'ПОЛНОЕ НАИМЕНОВАНИЕ НА РУССКОМ ЯЗЫКЕ',
          description: 'Акционерное общество «Банк 131»',
        },
        {
          title: 'СОКРАЩЕННОЕ НАИМЕНОВАНИЕ НА РУССКОМ ЯЗЫКЕ',
          description: 'АО «Банк 131»',
        },
        {
          title: 'ПОЛНОЕ НАИМЕНОВАНИЕ НА АНГЛИЙСКОМ ЯЗЫКЕ',
          description: 'Bank 131 Joint Stock Company',
        },
        {
          title: 'СОКРАЩЕННОЕ НАИМЕНОВАНИЕ НА АНГЛИЙСКОМ ЯЗЫКЕ',
          description: '«Bank 131» JSC',
        },
        {
          title: 'ЮРИДИЧЕСКИЙ АДРЕС',
          description: BANK_ADDRESS,
        },
        {
          title: 'ПОЧТОВЫЙ АДРЕС',
          description: BANK_ADDRESS,
        },
        {
          title: 'ФАКТИЧЕСКИЙ АДРЕС',
          description: BANK_ADDRESS,
        },
        {
          title: 'РЕГИСТРАЦИОННЫЙ НОМЕР',
          description: '3538',
        },
        {
          title: 'ЛИЦЕНЗИЯ',
          description:
            'Базовая лицензия на осуществление банковских операций со средствами <br/>' +
            'в рублях и иностранной валюте (с правом привлечения во вклады денежных средств физических лиц) и на осуществление банковских операций <br/>' +
            'с драгоценными металлами № 3538 от 29.11.2024г.',
        },
        {
          title: 'УСТАВНЫЙ КАПИТАЛ БАНКА',
          description: '340 000 000 рублей',
        },
        {
          title: 'УЧАСТИЕ В СИСТЕМЕ ОБЯЗАТЕЛЬНОГО СТРАХОВАНИЕ ВКЛАДОВ',
          description: 'Нет',
        },
        {
          title: 'ИНН / КПП',
          description: BANK_INN_KPP,
        },
        {
          title: 'ОГРН',
          description: BANK_OGRN,
        },
        {
          title: 'ДАТА ПРИСВОЕНИЯ ОГРН',
          description: '29 ноября 2024 года',
        },
        {
          title: 'КОРРЕСПОНДЕНТСКИЙ СЧЕТ',
          description:
            `${BANK_CORR_ACC} в Операционно-кассовом центре № 6 Волго-Вятского главного управления Центрального банка Российской Федерации`,
        },
        {
          title: 'БИК БАНКА',
          description: BANK_BIK,
        },
        {
          title: 'КЛАССИФИКАТОРЫ В СТАТИСТИЧЕСКОМ РЕГИСТРЕ',
          description:
            'ОКПО 58583325 ОКАТО 92401367000 <br/>' +
            'ОКТМО 92701000001 ОКОГУ 4210014<br/>' +
            'ОКФС 16 ОКОПФ 12267<br/>' +
            'ОКВЭД 64.19 Денежное посредничество прочее',
        },
        {
          title: 'ОФИЦИАЛЬНЫЕ САЙТЫ БАНКА',
          description: 'www.131.ru',
        },
        {
          title: 'ЭЛЕКТРОННАЯ ПОЧТА',
          description: 'help@131.ru',
        },
        {
          title: 'ТЕЛЕФОН',
          description: formatPhoneNumber(BANK_PHONE)
        },
        {
          title: 'РЕЖИМ РАБОТЫ',
          description:
            'Понедельник – пятница: с 09:00 до 18:00 (обед с 13:00 до 14:00, время мск);<br/>' +
            'Суббота - воскресенье: выходные (нерабочие) дни.',
        },
      ],
      description:
        'Вся размещенная на сайте информация представлена только для общего ознакомления и не является публичной офертой.<br/>' +
        '<br/>' +
        'Лицо, ответственное за полноту, достоверность и актуальность публикуемых на Web-сайте сведений: Ерошина Елена, press@131.ru<br/>' +
        '<br/>' +
        'Надзор за деятельностью АО «Банк 131», рег номер 3538: Банковский надзор за деятельностью кредитной организации (АО «Банк 131») осуществляет Служба текущего банковского надзора Банка России.<br/>' +
        '<br/>' +
        'Телефоны Контактного центра Центрального банка Российской Федерации: адрес: 107016, г. Москва, ул. Неглинная, 12, тел. 8-800-250-4072, 8-495-771-9100.<br/>' +
        '<br/>' +
        'Надзор за соблюдением требований законодательства Российской Федерации в сфере защиты прав потребителей финансовых услуг осуществляет Служба по защите прав потребителей и обеспечению доступности финансовых услуг Банка России.<br/>' +
        '<br/>' +
        'Обращение о нарушении действиями (бездействием) кредитной организации законодательства Российской Федерации, а также охраняемых законом прав и интересов физических или юридических лиц может быть направлено для рассмотрения в Банк России через интернет-приемную <br/>' +
        '(www.cbr.ru/Интернет-приемная).<br/>' +
        '<br/>' +
        'Вся размещенная на сайте информация представлена только для общего ознакомления <br/>' +
        'и не является публичной офертой. Та информация, которая на данный момент отсутствует, <br/>' +
        'скоро появится и мы добавим ее на сайт.',
    },
    centralBankLicense: [
      {
        label: 'Дата размещения 09.08.2019',
        title: 'Лицензия ЦБ РФ № 3538 от 12 апреля 2019.PDF',
        link: centralBankLicense,
      },
      {
        label: 'Дата размещения 11.01.2021',
        title: 'QR-Лицензия ЦБ РФ № 3538 от 12 апреля 2019.pdf',
        link: Base_QR,
      },
    ],
    pciDSSCertified: [
      {
        label: 'Дата размещения 19.08.2026',
        title: 'Сертификат PCI DSS.PDF',
        link: pciDSSCertified,
      },
    ],
    listInsiderInfo: [
      {
        label: 'Дата размещения 17.07.2026',
        title: 'Перечень инсайдерской информации АО «Банк 131», вступает в действие с 20.07.2026.PDF',
        link: listInsiderInfo_2026
      },
      {
        label: 'Дата размещения 22.11.2022',
        title: 'Перечень инсайдерской информации АО «Банк 131».PDF',
        link: listInsiderInfo_2022
      }
    ],
    pdProtection: [
      {
        label: 'Дата размещения 19.09.2023',
        title:
          'Политика АО «Банк 131» в отношении обработки персональных данных.PDF',
        link: pdProtection,
      },
    ],
    2022: [
      {
        label: 'Дата размещения 15.03.2023',
        title:
          'Годовая бухгалтерская финансовая отчетность <nobr>за 2022 год.pdf</nobr>',
        link:
          '/legal/ru/Godovaya_buhgalterskaya_finansovaya_otchetnost_za_2022_god.pdf',
        clarification: {
          label: '',
          text:
            'Годовая бухгалтерская (финансовая) отчетность за 2022 год, сформированная с учетом принятых Советом директоров Банка России 29 декабря 2022 года решением «О требованиях к раскрытию кредитными организациями (головными кредитными организациями банковских групп) отчетности и информации в 2023 году».',
        },
      },
      {
        label: 'Дата размещения 15.03.2023',
        title:
          'Аудиторское заключение о годовой бухгалтерской финансовой отчетности <nobr>за 2022 год.pdf</nobr>',
        link:
          '/legal/ru/Auditorskoe_zaklyuchenie_o_godovoj_buhgalterskoj_finansovoj_otchetnosti_za_2022_god.pdf',
      },
      {
        label: 'Дата размещения 15.03.2023',
        title: 'Решение Совета директоров Банка России от 29.12.2022 года.pdf',
        link:
          '/legal/ru/Reshenie_Soveta_direktorov_Banka_Rossii_ot_29_12_2022_goda.pdf',
      },
    ],
    2021: [
      {
        label: 'Дата размещения 11.11.2021',
        title:
          'Промежуточная бухгалтерская (финансовая) отчетность за 9 месяцев 2021 года.pdf',
        link:
          '/legal/ru/promezhutochnaya_buhgalterskaya_finansovaya_otchetnost_za_9_mes_2021.pdf',
      },
      {
        title:
          'Пояснительная информация к отчетности за 9 месяцев 2021 года.pdf',
        link:
          '/legal/ru/poyasnitelnaya_informaciya_k_otchetnosti_za_9_mes_2021.pdf',
      },
      {
        label: 'Дата размещения 11.08.2021',
        title:
          'Промежуточная бухгалтерская (финансовая) отчетность за первое полугодие 2021.pdf',
        link:
          '/legal/ru/promezhutochnaya_buhgalterskaya_finansovaya_otchetnost_za_pervoe_polugodie_2021.pdf',
      },
      {
        title:
          'Пояснительная информация к отчетности за первое полугодие 2021.pdf',
        link:
          '/legal/ru/poyasnitelnaya_informaciya_k_otchetnosti_za_pervoe_polugodie_2021.pdf',
      },
      {
        label: 'Дата размещения 14.05.2021',
        title:
          'Пояснительная информация к отчетности за первый квартал 2021 года.pdf',
        link: '/legal/ru/Poyasnitelnaya_inf_first_kvartal_2021.pdf',
      },
      {
        title:
          'Промежуточная бухгалтерская финансовая отчетность за первый квартал 2021 года.pdf',
        link: '/legal/ru/ru_first_kvartal_2021.pdf',
        clarification: {
          label: 'Дата размещения 21.04.2021',
          text:
            'Дата проведения очередного (годового) общего собрания участников (дата принятия решения ' +
            'единственного участника Акционерного общества «Банк 131») - 16.04.2021.',
        },
      },
    ],
    2020: [
      {
        label: 'Дата размещения 04.03.2021',
        title: 'Годовая бухгалтерская (финансовая) отчетность за 2020 год.pdf',
        link:
          '/legal/ru/Godovaya_buhgalterskaya_finansovaya_otchetnost_za_2020_god.pdf',
      },
      {
        title:
          'Пояснительная информация к годовой бухгалтерской финансовой отчетности за 2020 год.pdf',
        link:
          '/legal/ru/Poyasnitelnaya_informaciya_k_godovoj_buhgalterskoj_finansovoj_otchetnosti_za_2020_god.pdf',
      },
      {
        title:
          'Аудиторское заключение о годовой бухгалтерской финансовой отчетности.pdf',
        link:
          '/legal/ru/Auditorskoe_zaklyuchenie_o_godovoj_buhgalterskoj_finansovoj_otchetnosti.pdf',
      },
      {
        label: 'Дата размещения 12.11.2020',
        title:
          'Промежуточная бухгалтерская (финансовая) отчетность за 9 месяцев 2020 года.pdf',
        link: otchetnost_9_mes_2020,
      },
      {
        title:
          'Пояснительная информация к отчетности за 9 месяцев 2020 года.pdf',
        link: poyasnitelnaya_inf_k_otchetnosti_9_mes_2020,
      },
      {
        label: 'Дата размещения 10.08.2020',
        title:
          'Промежуточная бухгалтерская (финансовая) отчетность за первое полугодие 2020.pdf',
        link: otchetnost_1_polugodie_2020,
      },
      {
        title:
          'Пояснительная информация к отчетности за первое полугодие 2020.pdf',
        link: poyasnitelnaya_inf_k_otchetnosti_1_polugodie_2020,
      },
      {
        label: 'Дата размещения 18.05.2020',
        title: 'Публикуемая отчетность за первый квартал 2020.zip',
        link: '/legal/ru/ru_first_kvartal_2020.zip',
        clarification: {
          label: 'Дата размещения 29.04.2020',
          text:
            'Дата проведения очередного (годового) общего собрания участников (дата принятия решения ' +
            'единственного участника Акционерного общества «Банк 131») — 27.04.2020.',
        },
      },
    ],
    2019: [
      {
        label: 'Дата размещения 03.03.2020',
        title: 'Годовая бухгалтерская (финансовая) отчетность за 2019 год.zip',
        link: '/legal/ru/ru_publ_03032020.zip',
      },
      {
        title:
          'Аудиторское заключение о годовой бухгалтерской (финансовой) отчетности за 2019 год.pdf',
        link: audit_2019,
      },
      {
        label: 'Дата размещения 07.11.2019',
        title: 'Публикуемая отчетность за 9 месяцев 2019 года.zip',
        link: '/legal/ru/ru_9_mes_2019.zip',
      },
      {
        label: 'Дата размещения 09.08.2019',
        title: 'Публикуемая отчетность за первое полугодие 2019 года.zip ',
        link: '/legal/ru/ru_1_polugodie_2019.zip',
      },
    ],
    depositInsurance: {
      information:
      '<p>АО «Банк 131» является участником системы обязательного страхования вкладов.</p>'
      +`<ul><li><p><a href=${certificate} target="_blank">Свидетельство о включении АО «Банк 131»  в реестр банков – участников системы обязательного страхования вкладов</a></p></li>`
      +'<li><p>Федеральный закон <a href="https://www.cbr.ru/banking_sector/acts/177-fz/" target="_blank">«О страховании вкладов в банках Российской Федерации»</a></p></li>'
      +`<li><p><a href=${booklet} target="_blank">Справочник вкладчика</a></p></li></ul>`
      +'<p>С подробной информацией о вкладах, подлежащих страхованию в соответствии с указанным федеральным законом, о размере возмещения по вкладам, описанием порядка обращения вкладчика в ГК «АСВ» с требованием о выплате возмещения по вкладам, порядком выплаты возмещения по вкладам, информацией о праве вкладчика на получение оставшейся после выплаты возмещения части вклада, а также с <a href="https://www.asv.org.ru/support" target="_blank">ответами на вопросы</a> о системе страхования вкладов вы можете ознакомиться на сайте ГК «АСВ» (<a href="https://www.asv.org.ru/" target="_blank">www.asv.org.ru</a>)</p>'
      +'<br/>'
      +'<h4>Реквизиты ГК «АСВ»:</h4>'
      +'<p>Полное наименование: Государственная корпорация «Агентство по страхованию вкладов»</p>'
      +'<p>Адрес: 109240, г. Москва, ул. Высоцкого, д. 4 </p>'
      +'<p>Адрес электронной почты: <a href="mailto:info@asv.org.ru">info@asv.org.ru</a></p>'
      +'<p>Телефон горячей линии: 8 800 200-08-05 (бесплатный звонок по России) </p>'
      +'<p>Адрес официального сайта Агентства в сети «Интернет»: <a href="https://www.asv.org.ru/" target="_blank">https://www.asv.org.ru</a></p>',
    },
    osms2020Report: [
      {
        label: 'Дата размещения 18.05.2020',
        title: 'Отчет СОУТ 2020 года.pdf',
        link: suot_2020,
      },
    ],
    fatcaCompliance: {
      information:
        'Настоящим АО «Банк 131» информирует Вас, что в соответствии с Федеральным Законом ' +
        'от 28.06.2014 № 173-ФЗ «Об особенностях осуществления финансовых операций с иностранными гражданами и ' +
        'юридическими лицами, о внесении изменений в Кодекс Российской Федерации ' +
        'об административных правонарушениях и признании утратившими силу отдельных положений законодательных ' +
        'актов Российской Федерации» и FATCA (Foreign Account Tax Compliance Act) — закона США, Глава 4 ' +
        'Налогового кодекса США, который обязывает неамериканские финансовые институты идентифицировать ' +
        'клиентов-налогоплательщиков США, их выгодоприобретателей и (или) лиц, прямо или косвенно их ' +
        'контролирующих и передавать информацию по денежным средствам на их счетах в Налоговую службу ' +
        'США (Internal Revenue Service, IRS), Банк осуществил регистрацию в Налоговой службе США (IRS).',
      clarification:
        'ООО “Банк 131” зарегистрирован в качестве участвующего финансового института (Participating ' +
        'Foreign Financial Institution, PFFI) и получил глобальный идентификационный номер посредника ' +
        '(Global Intermediary Identification Number, GIIN): 4NB0VB.99999.SL643.',
      theMainGoal:
        'Основной целью Закона FATCA является противодействие уклонению от налогообложения в США ' +
        'доходов Налогоплательщиков США, полученных через финансовые институты за пределами США.<br/>' +
        '<br/>' +
        'С 09.01.2020 Банк осуществляет сбор сведений, позволяющих определить принадлежность обратившегося лица ' +
        'в Банк, для установления деловых взаимоотношений, к лицам, на которых распространяется законодательство ' +
        'иностранного государства о налогообложении иностранных счетов.<br/>' +
        '<br/>' +
        'При заключении договора по любой услуге Вам необходимо заполнить анкету Банка, содержащую ' +
        'дополнительные сведения FATCA (далее — Анкета). А также, для подтверждения налогового резидентства ' +
        'работник АО «Банк 131» вправе задать уточняющие вопросы, и попросить заполнить форму самосертификации:',
      taxResidentStatusForAnIndividual: {
        title:
          'Форма подтверждения статуса налогового резидента для физического лица (в том числе лица, ' +
          'занимающегося частной практикой, и индивидуального предпринимателя);',
        link: '/legal/ru/PERSONAL_SELF-CERTIFICATION_FORM(FATCA).doc',
      },
      taxResidentStatusOfALegalEntity: {
        title:
          'Форма подтверждения статуса налогового резидента (для юридического лица, в том числе ' +
          'иностранной организации без образования юридического лица).',
        link: '/legal/ru/SELF-CERTIFICATION_FORM_OF_LEGAL_ENTITY(FATCA).doc',
      },
      footnote: [
        {
          text:
            'Обращаем Ваше внимание, что Банк не консультирует клиентов по вопросам применения ' +
            'Закона FATCA. В случае возникновения вопросов рекомендуем Вам проконсультироваться ' +
            'с профессиональным налоговым консультантом. А также, в случае возникновения вопросов относительно ' +
            'действия закона FATCA и его применения, рекомендуем Вам обратиться к веб-сайту Налоговой службы ' +
            'США: <a href="https://www.irs.gov/" target="_blank">https://www.irs.gov/</a>',
        },
      ],
      informationForClients: 'Информация для клиентов — физических лиц',
      additionalDocuments:
        'От Вас Банк вправе потребовать предоставление следующих дополнительных документов ' +
        'в зависимости от Ваших ответов на вопросы Анкеты:',
      additionalDocumentsFootnote: [
        {
          text:
            'Вы являетесь гражданином США /налоговым резидентом США. Вам необходимо предоставить заполненную форму W-9 (форма W-9 размещена на сайте \n' +
            'Налоговой службы США: ' +
            '<a href="http://www.irs.gov/pub/irs-pdf/fw9.pdf" target="_blank">http://www.irs.gov/pub/irs-pdf/fw9.pdf</a>).',
          numbering: '1.',
        },
        {
          text:
            'Вы родились в США, но не являетесь гражданином США. Вам необходимо предоставить:',
          numbering: '2.',
        },
      ],
      subAdditionalDocumentsFootnote: [
        {
          text:
            'свидетельство об утрате гражданства США по форме DS 4083 Бюро консульских ' +
            'дел Государственного департамента США',
          numbering: 'a.',
        },
        {
          text:
            'письменные объяснения в отношении отсутствия гражданства в США (например, указание причины, ' +
            'по которой не было получено гражданство США по рождению).',
          numbering: 'b.',
        },
      ],
      legalEntities: 'Информация для клиентов — юридических лиц',
      legalEntitiesDescription:
        'От Вас Банк вправе потребовать предоставление следующих дополнительных ' +
        'документов в зависимости от Ваших ответов на вопросы Анкеты: соответствующие формы Налоговой ' +
        'службы США W-9 / W-8 и иные документы.',
      legalEntitiesLink: [
        {
          title: 'Форма W-8BEN-E АО «Банк 131»',
          link: W_8BEN_E,
        },
        {
          title: 'Форма W-8IMY АО «Банк 131»',
          link: W_8IMY,
        },
        {
          title:
            'Критерии отнесения клиентов к категории клиента-иностранного налогоплательщика \n' +
            'и способы получения от них необходимой информации',
          link: '/legal/ru/Grounds_for_classification_as_foreign_taxpayers.doc',
        },
        {
          title:
            'Согласие/отказ на передачу информации иностранным налоговым органам, уполномоченным органам РФ',
          link: '/legal/ru/INFORMATION_PERMIT.docx',
        },
        {
          title: 'Глоссарий',
          link: glossary,
        },
      ],
    },
    crsCompliance: {
      information:
        '<span class="bold">CRS. (Common Reporting Standard)</span> — Стандарт по автоматическому обмену информацией ' +
        'о финансовых счетах, разработанный ОЭСР (Организацией экономического сотрудничества ' +
        'и развития).<br/>' +
        '<br/>' +
        '<span class="bold">CRS</span> — это международный аналог FATCA, направленный на увеличение налоговой прозрачности ' +
        'и предотвращение глобального уклонения от уплаты налогов.<br/>' +
        '<br/>' +
        'Российская Федерация в мае 2016 года подтвердила свое участие в выполнении требований CRS. Согласно ' +
        'Федеральному закону от 27.11.2017 N 340-ФЗ «О внесении изменений в часть первую Налогового кодекса ' +
        'РФ в связи с реализацией международного автоматического обмена информацией и документацией по ' +
        'международным группам компаний» <span class="bold">лица, заключающие (заключившие) с Банком договор, предусматривающий ' +
        'оказание финансовых услуг обязаны предоставлять в Банк информацию, позволяющую установить налоговое ' +
        'резидентство, в отношении самих себя, выгодоприобретателей и (или) лиц, прямо или косвенно их контролирующих.</span><br/>' +
        '<br/>' +
        'Налоговый кодекс РФ содержит положения, согласно которым российские банки обязаны ' +
        'идентифицировать/ выявлять клиентов, выгодоприобретателей и (или) лиц, прямо или косвенно ' +
        'их контролирующих, являющихся налоговыми резидентами иностранных государств (территорий), ' +
        'и представлять данные о них и их счетах в ФНС России.<br/>' +
        '<br/>' +
        'Клиенты, в свою очередь, обязаны в соответствии с Налоговым кодексом РФ предоставлять запрашиваемую ' +
        'Банком информацию о налоговом резидентстве указанных лиц.<br/>' +
        '<br/>' +
        'В случае непредставления вышеуказанной информации при заключении с Банком договоров, предусматривающих ' +
        'оказание финансовых услуг, Банк вправе:',
      footnote: [
        {
          text: 'отказать в заключении такого договора;',
          numbering: '—',
        },
        {
          text:
            'отказать в совершении операций, осуществляемых в пользу или по поручению клиента по ' +
            'договору, предусматривающему оказание финансовых услуг;',
          numbering: '—',
        },
        {
          text:
            'расторгнуть в одностороннем порядке договор, предусматривающий оказание финансовых услуг, ' +
            'уведомив об этом клиента не позднее одного рабочего дня, следующего за днем принятия решения.',
          numbering: '—',
        },
      ],
      secondInformation:
        'Банк вправе в одностороннем порядке расторгнуть заключенный с клиентом договор, предусматривающий оказание финансовых услуг, если в результате проведения мер, предусмотренных пунктом 1 статьи 142.4 Главы 20.1 НК РФ, Банк выявит недостоверность \n' +
        'или неполноту представленной клиентом информации либо придет к выводу о противоречии представленной клиентом информации сведениям, имеющимся в распоряжении Банка, ' +
        'в том числе полученным из иных общедоступных источников информации.<br/>' +
        '<br/>' +
        'Для целей исполнения Российского законодательства АО «Банк 131» должен установить является ли клиент, его выгодоприобретатель и (или) лица, прямо или косвенно их контролирующие «налоговым резидентом» с указанием страны налогового резидентства. АО «Банк 131» имеет возможность определить статус «налогового резидента» Клиента на основании уже имеющейся \n' +
        'в АО «Банк 131» информации, но также могут быть запрошены для заполнения и направления \n' +
        'в АО «Банк 131» соответствующие Формы подтверждения статуса налогового резидента.<br/>' +
        '<br/>' +
        'АО «Банк 131» не оказывает консультационные услуги по вопросам определения налогового резидентства согласно требованиям CRS. По данному вопросу можно ознакомиться \n' +
        'с информацией по налоговому резидентству для разных стран на портале \n' +
        'Организации экономического сотрудничества и развития по адресу:<br/> <a href="http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency/#d.en.347760" target="_blank">http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency/#d.en.347760</a><br/>' +
        '<br/>' +
        'Для подтверждения налогового резидентства работник АО «Банк 131» вправе задать уточняющие вопросы, а также попросить заполнить форму самосертификации:',
      informationLink: [
        {
          title:
            'Форма подтверждения статуса налогового резидента для физического лица (в том числе лица, занимающегося частной практикой, и индивидуального предпринимателя)',
          link: '/legal/ru/PERSONAL_SELF-CERTIFICATION_FORM(CRS).doc',
        },
        {
          title:
            'Форма подтверждения статуса налогового резидента (для юридического лица, \n' +
            'в том числе иностранной организации без образования юридического лица).',
          link: '/legal/ru/SELF-CERTIFICATION_FORM_OF_LEGAL-ENTITY(CRS).doc',
        },
      ],
      legalEntities: 'Информация для клиентов — юридических лиц',
      legalEntitiesDescription:
        'О структуре формирования ИИНН (TIN) доступна по ссылке на сайт ОЭСР — <a href="http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers" target="_blank">http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers</a><br/>' +
        '<br/>' +
        'Касательно налогового резидентства в иностранных государствах доступна по ссылке на сайт ОЭСР — <a href="http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency/#d.en.347760" target="_blank">http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency/#d.en.347760</a><br/>' +
        '<br/>' +
        'Список государств, предоставляющий инвестиционное резидентство размещен на сайте ОЭСР — <a href="http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/residence-citizenship-by-investment/" target="_blank">http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/residence-citizenship-by-investment/</a><br/>' +
        '<br/>' +
        'ФНС России открыл на официальном сайте раздел, посвященный международному автоматическому обмену информацией, где публикуются документы и часто задаваемые вопросы: <a href="https://340fzreport.nalog.ru/" target="_blank">https://340fzreport.nalog.ru/</a>',
    },
    bpa: {
      rectangle: [
        {
          title: 'ПОЛНОЕ НАИМЕНОВАНИЕ',
          description: 'Общество с ограниченной ответственностью «Аккорд»',
        },
        {
          title: 'Юридический адрес',
          description:
            '129626, г. Москва, переулок Графский, д.14Б, этаж 2, пом 24',
        },
        {
          title: 'ИНН',
          description: '9717091209',
        },
        {
          title: 'КПП',
          description: '771701001',
        },
        {
          title: 'ОГРН',
          description: '1207700137171',
        },
        {
          title: 'Банковские реквизиты',
          description:
            'ПАО Промсвязьбанк <br />р/с 40702810602000080159 <br />к/с 30101810300000000760 <br />БИК 047888760',
        },
        {
          title: 'Сайт',
          description:
            '<a href="https://instant-pay.ru" target="_blank">https://instant-pay.ru</a>',
        },
        {
          title: '№ договора',
          description: 'ВР-051 от 22.07.2021',
        },
      ],
    },
    ombudsman: {
      information:
        '<h3>Информация о праве потребителей финансовых услуг на направление обращения финансовому уполномоченному</h3>' +
        '<p>С 1 января 2021 года действует новый досудебный порядок урегулирования споров потребителей с кредитными организациями.</p>' +
        '<p>В случае если кредитная организация отказывается удовлетворить требования потребителя, до обращения в суд потребитель для урегулирования спора должен обратиться к финансовому уполномоченному.</p>' +
        '<p>Должность финансового уполномоченного учреждена Федеральным законом от 4 июня 2018 года № 123-ФЗ «Об уполномоченном по правам потребителей финансовых услуг» (далее – Закон).</p>' +
        '<p>Финансовый уполномоченный рассматривает имущественные требования потребителя, размер которых не превышает 500000 рублей.</p>' +
        '<p>Обращение потребителя финансовому уполномоченному может быть направлено в электронной форме <a href="https://finombudsman.ru/lk/login" target="_blank">через личный кабинет</a> на официальном сайте финансового уполномоченного или в письменной форме.</p>' +
        '<p>Прием и рассмотрение обращений потребителей осуществляется финансовым уполномоченным бесплатно.</p>' +
        '<p>До направления обращения финансовому уполномоченному потребитель должен обратиться с заявлением (претензией) в кредитную организацию. Данный претензионный порядок установлен статьей 16 Закона и является обязательным для потребителей.</p>' +
        '<p>С подробной информацией о порядке направления обращения финансовому уполномоченному можно ознакомиться <a href="https://finombudsman.ru/" target="_blank">на официальном сайте</a> финансового уполномоченного.</p>' +
        '<p>Официальный сайт финансового уполномоченного: <a href="https://finombudsman.ru/" target="_blank">www.finombudsman.ru</a> </p>' +
        '<p>Номер телефона службы обеспечения деятельности финансового уполномоченного: 8 (800) 200-00-10 (бесплатный звонок по России).</p>' +
        '<p>Место нахождения службы обеспечения деятельности финансового уполномоченного: 119017, г. Москва, Старомонетный переулок, дом 3.</p>' +
        '<p>Почтовый адрес службы обеспечения деятельности финансового уполномоченного: 119017, г. Москва, Старомонетный переулок, дом 3, получатель АНО «СОДФУ».</p>',
    },
    importantUpdates: [
      {
        title: 'Изменения в составе совета директоров',
        clarification: {
          label: '',
          text:
            '<b style="display: contents;">Изменения в составе совета директоров</b><br />' +
            '04.05.2022 г. прекращены полномочия следующих членов совета директоров ООО «Банк 131»: ' +
            'Еремеева Д.Н., Еремеева С.Н., Еремеева Н.О. 04.05.2022 г. избран новый состав членов совета ' +
            'директоров ООО «Банк 131». Полномочия ранее избранного состава членов совета директоров ' +
            '(Еремеева Д.Н., Еремеева С.Н., Еремеева Н.О.) прекращены.',
        },
      },
    ],
    infoRates: [
      {
        title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами',
      },
    ],
    codeOfCorporateEthics: [
      {
        title: 'Кодекс корпоративной этики'
      }
    ],
    regulationsOnCombatingCommercialBriberyAndCorruption: [
      {
        title: 'Положение о противодействии коммерческому подкупу и коррупции'
      }
    ],
  },

  listMenu: {
    aboutBank: {
      title: 'О банке',
      subMenu: [
        {
          title: 'Реквизиты',
          query: 'requisite',
        },
        {
          title: 'Офисы АО «Банк 131»',
          query: 'offices',
        },
      ],
    },
    legalInformation: {
      title: 'Правовая информация',
      subMenu: [
        {
          title: 'Лицензия Банка России',
          query: 'centralBankLicense',
        },
        {
          title: 'Сертификат PCI DSS',
          query: 'pciDSSCertified',
        },
        {
          title: 'Защита ПД',
          query: 'pdProtection',
        },
        {
          title: 'Соответствие FATCA',
          query: 'fatcaCompliance',
        },
        {
          title: 'Соответствие CRS',
          query: 'crsCompliance',
        },
        {
          title: 'Перечень инсайдерской информации',
          query: 'listInsiderInfo',
        },
      ],
    },
    financialStatements: {
      title: 'Финансовая отчетность',
      subMenu: [
        {
          title: '2026',
          query: '2026',
        },
        {
          title: '2025',
          query: '2025',
        },
        {
          title: '2024',
          query: '2024',
        },
        {
          title: '2023',
          query: '2023',
        },
        {
          title: '2022',
          query: '2022',
        },
        {
          title: '2021',
          query: '2021',
        },
        {
          title: '2020',
          query: '2020',
        },
        {
          title: '2019',
          query: '2019',
        },
      ],
    },
    otherReports: {
      title: 'Прочая информация',
      subMenu: [
        {
          title: 'Страхование вкладов',
          query: 'depositInsurance',
        },
        {
          title: 'Отчет СОУТ 2020 года',
          query: 'osms2020Report',
        },
        {
          title: 'Перечень БПА',
          query: 'bpa',
        },
        {
          title: 'Финансовый уполномоченный',
          query: 'ombudsman',
        },
        {
          title: 'Важная информация',
          query: 'importantUpdates',
        },
        {
          title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами',
          query: 'infoRates',
        },
        {
          title: 'Кодекс корпоративной этики',
          query: 'codeOfCorporateEthics',
        },
        {
          title: 'Положение о противодействии коммерческому подкупу и коррупции',
          query: 'regulationsOnCombatingCommercialBriberyAndCorruption',
        },
        {
          title: 'MirPay',
          link: '/mirpay',
        },
      ],
    },
  },

  requisite: {
    title: 'Реквизиты',
  },
  offices: {
    title: 'Офисы АО «Банк 131»',
  },
  bankManagement: {
    title: 'Руководство банка',
  },
  centralBankLicense: {
    title: 'Лицензия Банка России',
  },
  pciDSSCertified: {
    title: 'Сертификат PCI DSS',
  },
  listInsiderInfo: {
    title: 'Перечень инсайдерской информации',
  },
  pdProtection: {
    title: 'Защита ПД',
  },
  fatcaCompliance: {
    title: 'Соответствие FATCA',
  },
  crsCompliance: {
    title: 'Соответствие CRS',
  },
  2024: {
    title: 'Финансовая отчетность за 2024 год',
  },
  2023: {
    title: 'Финансовая отчетность за 2023 год',
  },
  2022: {
    title: 'Финансовая отчетность за 2022 год',
  },
  2021: {
    title: 'Финансовая отчетность за 2021 год',
  },
  2020: {
    title: 'Финансовая отчетность за 2020 год',
  },
  2019: {
    title: 'Финансовая отчетность за 2019 год',
  },
  depositInsurance: {
    title: 'Страхование вкладов',
  },
  osms2020Report: {
    title: 'Отчет СОУТ 2020 года',
  },
  bpa: {
    title: 'Банковский платежный агрегатор',
  },
  ombudsman: {
    title: 'Финансовый уполномоченный',
  },
  importantUpdates: {
    title: 'Важная информация',
  },
  infoRates: {
    title: 'Информация о процентных ставках по договорам банковского вклада с физическими лицами'
  },
  codeOfCorporateEthics: {
    title: 'Кодекс корпоративной этики',
  },
  regulationsOnCombatingCommercialBriberyAndCorruption: {
    title: 'Положение о противодействии коммерческому подкупу и коррупции'
  } 
};
